module.exports = __webpack_public_path__ + "static/img/qapause.b361808.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qapause.png
// module id = 6am0
// module chunks = 1